import { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import { CheckOutlined } from "@mui/icons-material";
import { Chip, Stack } from "@mui/material";

interface ISocialOffersDetailsTabsProps {
  changeTab: (tab: SocialApplyStatus) => void;
  selectedTab: SocialApplyStatus;
  applyCount?: Record<SocialApplyStatus, number>;
}

export const SocialOffersDetailsTabs = ({ changeTab, selectedTab, applyCount }: ISocialOffersDetailsTabsProps) => {
  return (
    <Stack>
      <Stack sx={{ pt: 2, pl: 8, flexDirection: "row", gap: 1 }}>
        <Chip
          label={`Prescriptions en cours ${applyCount ? `(${applyCount?.[SocialApplyStatus.PRESCRIPTION_FILLED]})` : ""}`}
          onClick={() => changeTab(SocialApplyStatus.PRESCRIPTION_FILLED)}
          {...(selectedTab === SocialApplyStatus.PRESCRIPTION_FILLED && {
            color: "primary",
            icon: <CheckOutlined fontSize="small" />,
          })}
        />
        <Chip
          label={`Candidats intégrés ${applyCount ? `(${applyCount?.[SocialApplyStatus.INTEGRATED_CANDIDATE]})` : ""}`}
          onClick={() => changeTab(SocialApplyStatus.INTEGRATED_CANDIDATE)}
          {...(selectedTab === SocialApplyStatus.INTEGRATED_CANDIDATE && {
            color: "primary",
            icon: <CheckOutlined fontSize="small" />,
          })}
        />
        <Chip
          label={`Candidats refusés ${applyCount ? `(${applyCount?.[SocialApplyStatus.REFUSED_STRUCTURE]})` : ""}`}
          onClick={() => changeTab(SocialApplyStatus.REFUSED_STRUCTURE)}
          {...(selectedTab === SocialApplyStatus.REFUSED_STRUCTURE && {
            color: "primary",
            icon: <CheckOutlined fontSize="small" />,
          })}
        />
      </Stack>
    </Stack>
  );
};
